import repository from "@/api/Seguridad.js";

export default {
  cerrarSesion() {
    let url = `/api/autorizacion/cerrar-sesion/`;
    return repository.post(url);
  }
};
